// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SCL7","placeholdersHeader":"styles_placeholdersHeader__3jsIj","editorStyle":"styles_editorStyle__SvBBU","placeholdersBox":"styles_placeholdersBox__137TW"};